.editor-container {
  position: relative;
  line-height: 20px;
  font-weight: 400;
  text-align: left;
}

.editor-inner {
  position: relative;
  min-height: 120px;
  max-height: 300px;
  overflow: auto;
}

.editor-inner-edit {
  background: white;
}

.editor-input {
  height: 100%;
  resize: none;
  position: relative;
  tab-size: 1;
  outline: 0;
  padding: 10px;
  caret-color: #444;
}
